// src/components/PatientProtectedRoute.jsx
import React from 'react';
import { Navigate, useLocation, Outlet } from 'react-router-dom';

const PatientProtectedRoute = ({ children }) => {
  // Verificar si hay un token de paciente en localStorage
  const patientToken = localStorage.getItem('patientToken');
  const location = useLocation();
  
  // Si no hay token, redirigir al login de pacientes
  if (!patientToken) {
    return <Navigate to="/patient/login" replace state={{ from: location }} />;
  }
  
  // Si hay token, mostrar el contenido protegido
  return children ?? <Outlet />;
};

export default PatientProtectedRoute;
